import { useState } from 'react';
import mediportalUrl from '../assets/mediportal.svg';
import { CopyIcon, CopyCheckIcon } from './icons.tsx';
import { buildMedirisPatientSearchHref } from '@/utils';
import styles from './RrnDisplay.module.css';

/** Formats an 11-digit RRN string as YY.MM.DD-NNN.CC */
function formatRrn(rrn: string): string {
  if (rrn.length !== 11) return rrn;
  return `${rrn.slice(0, 2)}.${rrn.slice(2, 4)}.${rrn.slice(4, 6)}-${rrn.slice(6, 9)}.${rrn.slice(9, 11)}`;
}

interface Props {
  rrn: string;
  firstName?: string | null;
  lastName?: string | null;
  /** ISO date: YYYY-MM-DD */
  birthDate?: string | null;
  /** Whether to show the copy-to-clipboard button. Defaults to true. */
  showCopyButton?: boolean;
  /** Whether to show the inline Mediris link. Defaults to true. */
  showMedirisLink?: boolean;
}

export function RrnDisplay({
  rrn,
  firstName,
  lastName,
  birthDate,
  showCopyButton = true,
  showMedirisLink = true,
}: Props) {
  const [copied, setCopied] = useState(false);

  function handleCopy(e: React.MouseEvent) {
    e.stopPropagation();
    navigator.clipboard.writeText(rrn).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  }

  const medirisHref = buildMedirisPatientSearchHref(firstName, lastName, birthDate);

  return (
    <span className={styles.row}>
      <span className={styles.wrapper}>
        <span className={styles.value}>{formatRrn(rrn)}</span>
        {showCopyButton && (
          <button
            type="button"
            className={styles.copyBtn}
            onClick={handleCopy}
            title={copied ? 'Gekopieerd!' : 'Kopieer RRN'}
            aria-label="Kopieer RRN"
          >
            {copied ? <CopyCheckIcon /> : <CopyIcon />}
          </button>
        )}
      </span>
      {showMedirisLink && medirisHref && (
        <a
          href={medirisHref}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.medirisLink}
          title="Openen in Mediris"
          aria-label="Openen in Mediris"
          onClick={(e) => e.stopPropagation()}
        >
          <img src={mediportalUrl} alt="Mediris" width="18" height="12" />
        </a>
      )}
    </span>
  );
}
